import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Header';
import KeyPerformanceAreas from "./KeyPerformanceAreas";
import PrinciplesAndStandards from "./PrinciplesAndStandards";
import PersonalDevelopmentPlan from "./PersonalDevelopmentPlan";
import OverallIndividualScore from "./OverallIndividualScore";
import {RatingsProvider} from "./RatingsContext";

const values = ["1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5",];
const PerformanceContractForm = () => {
  const [overallSelf, setOverallSelf] = useState(0);
  const [overallLineManager, setOverallLineManager] = useState(0);
  const [overallModerator, setOverallModerator] = useState(0);
  const [overallModeratorComment, setOverallModeratorComment] = useState('');
  const [kpaWeightTotal, setKpaWeightTotal] = useState(100);
  const [kpaSelfSectionA, setKpaSelfSectionA] = useState(3.5);
  const [kpaSelfSectionB, setKpaSelfSectionB] = useState(0);
  const [kpaLineManager, setKpaLineManager] = useState(3.5);
  const [selfKpa1, setSelfKpa1] = useState(3.5);
  const [selfKpa2, setSelfKpa2] = useState(3.5);
  const [selfKpa3, setSelfKpa3] = useState(3.5);
  const [weightSelfKPA1, setWeightSelfKPA1] = useState(40);
  const [weightSelfKPA2, setWeightSelfKPA2] = useState(20);
  const [weightSelfKPA3, setWeightSelfKPA3] = useState(40);

  const [weightSelfKPB1, setWeightSelfKPB1] = useState(50);
  const [weightSelfKPB2, setWeightSelfKPB2] = useState(30);
  const [weightSelfKPB3, setWeightSelfKPB3] = useState(20);
  const [sectionATotWeight, setSectionATotWeight] = useState(40);

  const [selfKpaB1, setSelfKpaB1] = useState(0);
  const [selfKpaB2, setSelfKpaB2] = useState(0);
  const [selfKpaB3, setSelfKpaB3] = useState(0);

  const handleMyKpa = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    let total = 0;

    if (name === 'selfKpa1'){
      total = (weightSelfKPA1/100) * value + (weightSelfKPA2/100) * selfKpa2 + (weightSelfKPA3/100) * selfKpa3;
      setSelfKpa1(value)
      setKpaSelfSectionA(customRound(total))

    }else if (name === 'selfKpa2'){
      total = (weightSelfKPA2/100) * value + (weightSelfKPA1/100) * selfKpa1 + (weightSelfKPA3/100) * selfKpa3;
      setSelfKpa2(value)
      setKpaSelfSectionA(customRound(total))

    }else if (name === 'selfKpa3'){
      total = (weightSelfKPA3/100) * value + (weightSelfKPA1/100) * selfKpa1 + (weightSelfKPA2/100) * selfKpa2;
      setSelfKpa3(value)
      setKpaSelfSectionA(customRound(total))

    }


  }

  const handleMyKpaSectionB = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    let total = 0;

    if (name === 'selfKpaB1'){
      total = (weightSelfKPB1/100) * value + (weightSelfKPB2/100) * selfKpaB2 + (weightSelfKPB3/100) * selfKpaB3;
      setSelfKpaB1(value)
      setKpaSelfSectionB(customRound(total))

    }else if (name === 'selfKpaB2'){
      total = (weightSelfKPB2/100) * value + (weightSelfKPB1/100) * selfKpaB1 + (weightSelfKPB3/100) * selfKpaB3;
      setSelfKpaB2(value)
      setKpaSelfSectionB(customRound(total))

    }else if (name === 'selfKpaB3'){
      total = (weightSelfKPA3/100) * value + (weightSelfKPA1/100) * selfKpaB1 + (weightSelfKPA2/100) * selfKpaB2;
      setSelfKpaB3(value)
      setKpaSelfSectionB(customRound(total))

    }


  }

  useEffect(() => {
    let total = (kpaSelfSectionA * 80/100) + (kpaSelfSectionB * 20/100);
    total = customRound(total);
    setOverallSelf(total);
  }, [kpaSelfSectionA, kpaSelfSectionB])

  function customRound(number) {
    const decimalPart = number - Math.floor(number);

    if (decimalPart === 0.5) {
      return number; // Don't round if the decimal part is exactly 0.5
    } else if (decimalPart < 0.5) {
      return Math.floor(number); // Round down for decimal parts less than 0.5
    } else {
      return Math.ceil(number); // Round up for decimal parts greater than 0.5
    }
  }


  return (
      <RatingsProvider>
      <Header icon={"fa-solid fa-users fa-xl mx-2"} label={"Current Review Cycle / My Performance Contract"} />
      <main id="main" className="main">

        <div className='row'>
          <div className='col-lg-12'>
            <div className='card'>

              <div className='card-body'>

                <div className='section'>
                  <div className="card pb-5 container">
                    <div className="card-body">
                      <div className="container mt-4">
                        <div className="d-flex align-items-center mb-3  bg-tertiary p-2 text-light rounded">
                          <h4 className="mb-0">Performance Contract</h4>
                        </div>
                        <div className='section-body p-3'>
                          <div className="col-md-4">
                            <form>
                              <div className="mb-3 d-flex align-items-center">
                                <label htmlFor="cycleReview" className="form-label me-3" style={{width: '200px'}}>Cycle Under Review:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="cycleReview"
                                    value="2024 Cycle Review"
                                    disabled
                                />
                              </div>
                              <div className="mb-3 d-flex align-items-center">
                                <label htmlFor="employeeName" className="form-label me-3" style={{width: '200px'}}>Employee Name:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="employeeName"
                                    value="Maxwell Mphioe"
                                    disabled
                                />
                              </div>
                              <div className="mb-3 d-flex align-items-center">
                                <label htmlFor="positionTitle" className="form-label me-3" style={{width: '200px'}}>Position Title:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="positionTitle"
                                    value="Software Developer: Strategic Projects"
                                    disabled
                                />
                              </div>
                              <div className="mb-3 d-flex align-items-center">
                                <label htmlFor="lineManager" className="form-label me-3" style={{width: '200px'}}>Line Manager:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="lineManager"
                                    value="Joe Slovo"
                                    disabled
                                />
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div className='section my-4'>
                  <div className="card pb-5 container">
                    <div className="card-body"><OverallIndividualScore /></div>
                  </div>

                  <div className="card pb-5 container">
                    <div className="card-body">
                      <KeyPerformanceAreas
                        phase='self-assessment'
                        myKpas={[
                          {
                            kpa: 'Risk Mitigation',
                            weight: '40',
                            selfRating: 3,
                            lineManagerRating: null,
                            kpis: [
                              {
                                description: 'Mentorship or Pair Programming Sessions',
                                resources: 'Technology and Tools, Budget, and Leadership Support.',
                                annualTarget: 'Aim to conduct a minimum of two mentorship or pair programming sessions per month to facilitate knowledge transfer and skill development within the team.',
                                measurement: 'Number of mentorship or pair sessions conducted with team members.',
                                progress: '10',
                                challenges: '',
                                correctiveMeasures: '',
                              },
                              {
                                description: 'Code Review Participation',
                                resources: 'Technology and Tools, Budget, and Leadership Support.',
                                annualTarget: 'Aim to actively participate in at least 90% of code reviews to provide valuable input and maintain code quality.',
                                measurement: 'Percentage of code reviews participated in within the team.',
                                progress: '10',
                                challenges: '',
                                correctiveMeasures: '',
                              },
                            ],
                          },
                          {
                            kpa: 'Bug Resolution Time - Average time taken to resolve and close reported software bugs.',
                            weight: '20',
                            selfRating: 3,
                            lineManagerRating: null,
                            kpis: [
                              {
                                description: 'Track the effectiveness of the risk management strategy by monitoring the number and impact of risks identified and mitigated during the project.',
                                resources: 'Achieve a target of mitigating 90% of identified risks annually.',
                                annualTarget: 'Achieve a target of mitigating 90% of identified risks annually.',
                                measurement: 'Technology and Tools, Budget, and Leadership Support',
                                progress: '',
                                challenges: '',
                                correctiveMeasures: '',
                              },
                            ],
                          },
                          {
                            kpa: 'On-Time Delivery',
                            weight: '40',
                            selfRating: 3,
                            lineManagerRating: null,
                            kpis: [
                              {
                                description: 'Track the effectiveness of the risk management strategy by monitoring the number and impact of risks identified and mitigated during the project.',
                                resources: 'Achieve a target of mitigating 90% of identified risks annually.',
                                annualTarget: 'Achieve a target of mitigating 90% of identified risks annually.',
                                measurement: 'Technology and Tools, Budget, and Leadership Support',
                                progress: '',
                                challenges: '',
                                correctiveMeasures: '',
                              },
                            ],
                          },
                        ]}
                    /></div>
                  </div>

                  <div className="card pb-5 container">
                    <div className="card-body"><PrinciplesAndStandards phase='self-assessment'  /></div>
                  </div>

                  <div className="card pb-5 container">
                    <div className="card-body"><PersonalDevelopmentPlan phase="capture-progress" /></div>
                  </div>
                </div>











                <div className="container d-flex">
                  <div className="d-flex">
                    <input type="radio" name="hello" className="mb-4"/>
                    <div className="ms-2">I have finalised my progress capturing</div>
                  </div>
                  <button className='btn btn-secondary btn-sm py-1 my-1 mt-2  text-nowrap ms-auto me-3'>SAVE</button>
                  
                  <button className='btn btn-tertiary btn-sm py-1 my-1 mt-2  text-nowrap'>SUBMIT</button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </main >
      </RatingsProvider>
  )
}
export default PerformanceContractForm;
